import { NimbuxHotelCheckOption } from "@bandido/shared/interfaces";
import { HotelCheckOptionType, InfoLanguage } from "@bandido/shared/enums";

export const getDefaultValues= ( type: HotelCheckOptionType ): NimbuxHotelCheckOption => ({
  type,
  instructions: {
    [InfoLanguage.English]: '',
    [InfoLanguage.Spanish]: '',
    [InfoLanguage.Portuguese]: '',
  },
  minAge: 18,
  startTime: '00:00',
  endTime: '23:59',
});
